import { FolderOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'

import Loader from '@/components/Atoms/Loader/Loader'
import ConstructionSiteCard from '@/components/ConstructionSites/ConstructionSiteCard/ConstructionSiteCard'
import ObjectCreationForm from '@/components/ConstructionSites/ConstructionSiteCreationForm/ConstructionSiteCreationForm'
import OrganisationBar from '@/components/OrganisationBar/OrganisationBar'
import useConstructionSites from '@/hooks/constructionSites/useConstructionSites'
import { useProfileStore } from '@/stores/user/profileStore'
import { ConstructionSiteInterface } from '@/types'

import cn from './ConstructionSites.module.scss'

function ConstructionSites() {
  const [constructionSitesLoading, setConstructionSitesLoading] =
    useState(false)
  const [fetchingError, setFetchingError] = useState<string>('')

  const {
    constructionSites,
    updateConstructionSites,
    setConstructionSites,
    setUpdateConstructionSites,
  } = useProfileStore((state) => state)

  const [, contextHolder] = Modal.useModal()

  const getConstructionSites = useConstructionSites({
    setConstructionSitesLoading,
    setConstructionSites,
  })

  const getConstructionSite = (type: 'main' | 'store') => {
    return constructionSites.find(
      (
        constructionSite: ConstructionSiteInterface['constructionSiteModel']
      ) => {
        if (constructionSite.isActive) {
          if (type === 'main') return constructionSite.isMain
          if (type === 'store') return constructionSite.isStore
        }
        return false
      }
    )
  }

  useEffect(() => {
    getConstructionSites().then((result) => {
      if (result?.status === 'error') {
        setFetchingError(result.message)
      }
    })
  }, [getConstructionSites])

  useEffect(() => {
    if (updateConstructionSites) {
      getConstructionSites().then((result) => {
        if (!result) return

        if (result.status === 'success') {
          toast.success(result.message)
        } else if (result.status === 'error') {
          toast.error(result.message)
          setFetchingError(result.message)
        } else if (result.status === 'warning') {
          toast.warning(result.message)
        } else {
          toast.info(result.message)
        }
      })
    }
  }, [getConstructionSites, updateConstructionSites])

  return (
    <>
      {contextHolder}
      <section className={cn.constructionSites}>
        <OrganisationBar />

        <div className={cn.headerBlock}>
          <h2 className={cn.pageTitle}>Объекты</h2>
          <Link to="/construction-sites/archive">
            <Button icon={<FolderOutlined />} type="default">
              Архив объектов
            </Button>
          </Link>
        </div>

        {constructionSitesLoading ? (
          <Loader paddingTop={120} />
        ) : fetchingError ? (
          <div className={cn.error}>{fetchingError}</div>
        ) : (
          <div className={cn.list}>
            {getConstructionSite('store') && (
              <ConstructionSiteCard
                constructionSite={getConstructionSite('store')!}
                location="constructionSites"
              />
            )}

            {getConstructionSite('main') &&
              !getConstructionSite('main')?.isStore && (
                <ConstructionSiteCard
                  constructionSite={getConstructionSite('main')!}
                  location="constructionSites"
                />
              )}

            {constructionSites
              .filter((cs) => cs.isActive && !cs.isMain && !cs.isStore)
              .map((constructionSite) => (
                <ConstructionSiteCard
                  constructionSite={constructionSite}
                  location="constructionSites"
                  key={constructionSite.id}
                />
              ))}

            {!updateConstructionSites && (
              <div className={cn.addConstructionSiteCard}>
                <p>Добавить объект</p>
                <ObjectCreationForm
                  location="constructionSites"
                  setUpdateConstructionSites={setUpdateConstructionSites}
                />
              </div>
            )}
          </div>
        )}
      </section>
    </>
  )
}

export default ConstructionSites
